/* „Passend dazu“: Search & Discovery + Auffüllen aus dem Rückfall (Produktseite und Warenkorb) */

(function () {
  document.querySelectorAll('[data-bd-passend]').forEach(function (el) {
  if (!el.querySelector('[data-bd-passend-rahmen]') || el.hasAttribute('data-bereit')) return;
  el.setAttribute('data-bereit', '');
  var rahmen = el.querySelector('[data-bd-passend-rahmen]'), raster = el.querySelector('[data-bd-passend-raster]');
  var id = el.getAttribute('data-id');
  var gezeigt = {}, quellen = [];
  gezeigt[id] = 1;
  (el.getAttribute('data-vorhanden') || '').split(',').forEach(function (x) { if (x) gezeigt[x] = 1; });
  function zeigen(karten, name) {
    var n = 0;
    karten.forEach(function (k) {
      var kid = k.getAttribute('data-id');
      if (gezeigt[kid] || raster.children.length >= 4) return;
      gezeigt[kid] = 1; raster.appendChild(k); n++;
    });
    if (n) { quellen.push(name + ':' + n); rahmen.hidden = false; rahmen.setAttribute('data-quelle', quellen.join(' ')); }
  }
  function auffuellen() {
    if (raster.children.length >= 4) return;
    var t = el.querySelector('[data-bd-rueckfall]');
    zeigen(t ? [].slice.call(t.content.querySelectorAll('.bd-passend__karte')) : [], 'rueckfall');
  }
  fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
    var d = document.createElement('div'); d.innerHTML = html;
    zeigen([].slice.call(d.querySelectorAll('[data-bd-empfohlen] .bd-passend__karte')), 'shopify');
    auffuellen();
  }).catch(auffuellen);
  el.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bd-dazu]'); if (!b) return;
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-bd-dazu'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; if (el.hasAttribute('data-neu-laden')) { window.location.reload(); return; } document.dispatchEvent(new CustomEvent('cart:build')); document.dispatchEvent(new CustomEvent('cart:open')); })
      .catch(function () {}).finally(function () { b.disabled = false; });
  });
  });
})();
